class EducationalResourcesArchive {
  constructor(element) {
    this.element = element;
    this.terms = this.element.querySelectorAll('[data-element="educational-resources-archive-term"]');
    this.sections = this.element.querySelector('[data-element="educational-resources-archive-sections"]');
    this.listTermId = 0;
    this.listPerPage = this.element.dataset.perPage;
    this.listPerLoad = this.element.dataset.perLoad;
    this.gridNumberOfColumns = this.element.dataset.gridNumberOfColumns;
    this.gridGap = this.element.dataset.gridGap;
    this.gridGapMobile = this.element.dataset.gridGapMobile;
    this.loader = this.element.querySelector('[data-element="educational-resources-archive-loader"]');
    this.rest = wpRestApi; // eslint-disable-line
  }

  init() {
    this.terms.forEach((term) => {
      term.addEventListener('click', this.onTermClick.bind(this, term));
    });

    this.initSections();
  }

  onLoadMoreBtnClick() {
    this.loadSections();
  }

  onTermClick(term) {
    if (term.classList.contains('is-active')) {
      return;
    }

    this.removeAllTermsActive();
    term.classList.add('is-active');
    this.clearSections();
    this.showLoader();
    this.listTermId = term.dataset.id;
    this.loadSections();
  }

  loadSections() {
    this.showLoader();

    const url = new URL(this.rest.url + 'educational-resource/filter');
    url.searchParams.append('term_id', this.listTermId);
    url.searchParams.append('per_page', this.listPerPage);
    url.searchParams.append('grid_number_of_columns', this.gridNumberOfColumns);
    url.searchParams.append('grid_gap', this.gridGap);
    url.searchParams.append('grid_gap_mobile', this.gridGapMobile);

    fetch(url.href, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      return response.json();
    }).then((data) => {
      if (null !== data.html) {
        this.sections.insertAdjacentHTML('beforeend', data.html);
      }

      this.initSections();
      this.hideLoader();
    }).catch((error) => {
      console.error(error);
      this.hideLoader();
    });
  }

  clearSections() {
    this.sections.replaceChildren();
  }

  removeAllTermsActive() {
    this.terms.forEach((term) => {
      term.classList.remove('is-active');
    });
  }

  hideLoader() {
    this.loader.classList.remove('educational-resources-archive__loader--show');
  }

  showLoader() {
    this.loader.classList.add('educational-resources-archive__loader--show');
  }

  initSections() {
    const sections = this.element.querySelectorAll('[data-element="educational-resources-archive-section"]');

    sections.forEach((section) => {
      const sectionLoadMore = section.querySelector('[data-element="educational-resources-archive-section-load-more"]');

      if (null !== sectionLoadMore) {
        const button = sectionLoadMore.querySelector('[data-element="educational-resources-archive-section-load-more-btn"]');
        button.addEventListener('click', this.onSectionLoadMoreClick.bind(this, section));
      }
    });
  }

  onSectionLoadMoreClick(section) {
    this.showSectionLoader(section);

    const url = new URL(this.rest.url + 'educational-resource/load-more');
    url.searchParams.append('term_id', this.listTermId);
    url.searchParams.append('category_id', section.dataset.category);
    url.searchParams.append('page', section.dataset.page);
    url.searchParams.append('per_page', this.listPerPage);
    url.searchParams.append('per_load', this.listPerLoad);

    fetch(url.href, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      return response.json();
    }).then((data) => {
      if (null !== data.html) {
        const list = section.querySelector('[data-element="educational-resources-archive-section-list"]');
        list.insertAdjacentHTML('beforeend', data.html);
      }

      if (true === data.hideBtn) {
        this.hideSectionLoadMore(section);
      }

      section.dataset.page++;
      this.hideSectionLoader(section);
    }).catch((error) => {
      console.error(error);
      this.hideSectionLoader(section);
    });
  }

  hideSectionLoadMore(section) {
    section.querySelector('[data-element="educational-resources-archive-section-load-more"]').classList.add('educational-resources-archive__section-loader-more--hidden');
  }

  showSectionLoadMore(section) {
    section.querySelector('[data-element="educational-resources-archive-section-load-more"]').classList.remove('educational-resources-archive__section-loader-more--hidden');
  }

  hideSectionLoader(section) {
    section.querySelector('[data-element="educational-resources-archive-section-load-more-loader"]').classList.remove('educational-resources-archive__section-loader--show');
  }

  showSectionLoader(section) {
    section.querySelector('[data-element="educational-resources-archive-section-load-more-loader"]').classList.add('educational-resources-archive__section-loader--show');
  }
}

const educationalResourcesArchive = {
  init() {
    const educationalResourcesArchiveElements = document.querySelectorAll('[data-module="educational-resources-archive"]');

    if (educationalResourcesArchiveElements && educationalResourcesArchiveElements.length) {
      educationalResourcesArchiveElements.forEach((element) => {
        const educationalResourcesArchiveElement = new EducationalResourcesArchive(element);
        educationalResourcesArchiveElement.init();
      });
    }
  },
};

export default educationalResourcesArchive;
